import { Carousel } from "./carousel.js";
import { styles } from "./carousel.styles.js";
import { template } from "./carousel.template.js";
import { DesignSystem } from "../design-system.js";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fabric-carousel>
 */
export const definition = Carousel.compose({
    name: `${DesignSystem.prefix}-carousel`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=carousel.definition.js.map